import React from 'react';
import Header from '../../componentes/comuns/Header';
import Footer from '../../componentes/comuns/Footer';
import Ofertas from '../../componentes/comuns/Ofertas';
import ServicosEssenciaisInternet from '../../componentes/comuns/ServicosEssenciaisInternet';
import InfinitePossibilities from '../../componentes/comuns/InfinitePossibilities';
import HelpSection from '../../componentes/comuns/HelpSection';
import FaixaPlanos from '../../componentes/comuns/FaixaPlanos';
import styles from './Internet.module.css';


const Planos = () => {
    return (
        <>
            <Header />
            <main>
                <div>
                    <Ofertas />
                </div>
                <div className={styles.faixaplanos}>
                    <FaixaPlanos/>
                </div>
                <div>
                    <ServicosEssenciaisInternet/>
                </div>
                <div>
                    <InfinitePossibilities/>
                </div>
                <div>
                    <HelpSection/>
                </div>
                
               
            </main>
            <Footer />
        </>
    );
}

export default Planos;